export const environment = {
  production: false,
  mock: false,
  api: {
    baseUrl: 'https://otb8672gsd.execute-api.us-west-2.amazonaws.com/dev',
  },
  cognito: {
    region: 'us-west-2',
    userPoolId: 'us-west-2_24cqKUFMX',
    clientId: '73u7p9hcp5pdune5ck4je16hno',
  },
};
